var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00007 12H9.0074M16.9248 4.08056C14.8371 2.16746 12.0549 1 8.99998 1C5.9451 1 3.1629 2.16746 1.0752 4.08056M3.67015 6.67818C5.09144 5.42615 6.95705 4.66667 9.00005 4.66667C11.043 4.66667 12.9087 5.42615 14.3299 6.67818M11.7122 9.26841C10.9648 8.6826 10.0232 8.33333 8.99998 8.33333C7.96129 8.33333 7.00666 8.69324 6.254 9.29516",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOn);
export default __webpack_public_path__ + "static/media/WifiOn.78ae4198.svg";
export { ForwardRef as ReactComponent };